export const documentKeys = {
  all: ['documents'] as const,
  lists: () => [...documentKeys.all, 'list'] as const,
  list: (caseId: string) => [...documentKeys.lists(), caseId] as const,
  details: () => [...documentKeys.all, 'detail'] as const,
  detail: (caseId: string, id: string) => [...documentKeys.details(), caseId, id] as const,
} as const;
